module.exports = __webpack_public_path__ + "static/img/title.5f8600c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/title.png
// module id = welx
// module chunks = 0